import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { PageHeader } from '@/components/shared/PageHeader';
import { ActivityLogTable } from '@/components/features/activity-logs/ActivityLogTable';
import { ActivityLogFilters } from '@/components/features/activity-logs/ActivityLogFilters';
import { ExportButton } from '@/components/shared/ExportButton';
import { useActivityLogs } from '@/lib/hooks';
import { exportActivityLogsToCSV } from '@/utils/export';
import type { ActivityLogFilters as ActivityLogFiltersType } from '@/lib/types';
import {DataTablePagination} from "@/components/shared";

export const Route = createFileRoute('/_auth/_admin/admin/activity-logs/')({
  component: ActivityLogsComponent,
});

function ActivityLogsComponent() {
  const [filters, setFilters] = useState<ActivityLogFiltersType>({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

    const { data, isLoading } = useActivityLogs({
        ...filters,
        page,
        per_page: perPage,
        from_date: filters.from_date,
        to_date: filters.to_date,
    });

  const handleExport = () => {
    if (data?.data) {
      exportActivityLogsToCSV(data.data);
    }
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Логи"
        description="Действия пользователей"
        action={<ExportButton onExportCSV={handleExport} disabled={!data?.data} />}
      />

      <ActivityLogFilters filters={filters} onFiltersChange={setFilters} />

      <ActivityLogTable
        data={data?.data || []}
        isLoading={isLoading}
      />

        {data?.meta && (
            <DataTablePagination
                meta={data.meta}
                onPageChange={setPage}
                onPerPageChange={setPerPage}
            />
        )}
    </div>
  );
}
